<template>
  <div class="form-filter">
    <div class="form-block">
      <div class="form-block-title">
        Создание наименования рекламной кампании
      </div>

      <div class="flex some-inputs">
        <div class="flex flex-col m-r-8 input-container">
          <label class="small-label">Бренд*</label>
          <SceletonInput :is-loading="isLoadingData">
            <CatalogDataSingleInput
              v-if="!customCatalogData.brand"
              selectType="brand"
              :is-invalid="isInvalidForm && campaign.brand == null"
              :isSegmentSetted="false"
              :modelValue="campaign.brand"
              @update:modelValue="($event) => (campaign.brand = $event)"
            ></CatalogDataSingleInput>
            <InputText
              v-else
              placeholder="Введите значение"
              v-model="campaign.brand_name"
            />
          </SceletonInput>
          <template
            v-if="authStore.getPayloadTenant() != rootGetters.inhouse_tenant"
          >
            <div class="hand" v-if="!customCatalogData.brand">
              <div>
                Не нашли бренд в списке?
                <span
                  @click="
                    customCatalogData.brand = true;
                    campaign.brand = null;
                  "
                  >Ввести вручную</span
                >
              </div>
            </div>
            <div class="hand" v-else>
              <div>
                <span
                  @click="
                    customCatalogData.brand = false;
                    campaign.brand_name = '';
                  "
                  >Выбрать из списка</span
                >
              </div>
            </div>
          </template>
        </div>
        <div class="flex flex-col input-container">
          <label class="small-label">Магазин*</label>
          <SceletonInput :is-loading="isLoadingData">
            <CatalogDataSingleInput
              v-if="!customCatalogData.shop"
              selectType="shop"
              :is-invalid="isInvalidForm && campaign.shop == null"
              :isSegmentSetted="false"
              :modelValue="campaign.shop"
              @update:modelValue="($event) => (campaign.shop = $event)"
            ></CatalogDataSingleInput>
            <InputText
              v-else
              placeholder="Введите значение"
              v-model="campaign.shop_name"
            />
          </SceletonInput>
          <template
            v-if="authStore.getPayloadTenant() != rootGetters.inhouse_tenant"
          >
            <div class="hand" v-if="!customCatalogData.shop">
              <div>
                Не нашли магазин в списке?
                <span
                  @click="
                    customCatalogData.shop = true;
                    campaign.shop = null;
                  "
                  >Ввести вручную</span
                >
              </div>
            </div>
            <div class="hand" v-else>
              <div>
                <span
                  @click="
                    customCatalogData.shop = false;
                    campaign.shop_name = '';
                  "
                  >Выбрать из списка</span
                >
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="flex some-inputs m-t-8">
        <div class="flex flex-col m-r-8 input-container">
          <label class="small-label">Стратегия</label>
          <SceletonInput :is-loading="isLoadingData">
            <InputText
              placeholder="Введите значение"
              v-model="campaign.strategy"
              :disabled="false"
            />
          </SceletonInput>
        </div>
        <div class="flex flex-col input-container">
          <label class="small-label">Дополнительное поле</label>
          <SceletonInput :is-loading="isLoadingData">
            <InputText
              placeholder="Введите значение"
              v-model="campaign.extra_info"
              :disabled="false"
            />
          </SceletonInput>
        </div>
      </div>

      <div class="flex some-inputs m-t-8">
        <div class="flex flex-col m-r-8 input-container">
          <label class="small-label"
            >Период запуска рекламной кампании от*</label
          >
          <SceletonInput :is-loading="isLoadingData">
            <CalendarBaseInput
              :modelValue="campaign.date_from"
              :is-invalid="isInvalidForm && campaign.date_from == null"
              @update:modelValue="($event) => (campaign.date_from = $event)"
              :disabled="false"
            ></CalendarBaseInput>
          </SceletonInput>
        </div>
        <div class="flex flex-col input-container">
          <label class="small-label"
            >Период запуска рекламной кампании до*</label
          >
          <SceletonInput :is-loading="isLoadingData">
            <CalendarBaseInput
              :min-date="new Date()"
              :modelValue="campaign.date_to"
              :is-invalid="isInvalidForm && campaign.date_to == null"
              @update:modelValue="($event) => (campaign.date_to = $event)"
              :disabled="false"
            ></CalendarBaseInput>
          </SceletonInput>
        </div>
      </div>

      <TechCampaignToggle
        v-if="!isCampaignSetted"
        :campaign="campaignData"
        :isLoadingData="isLoadingData"
        @update:campaign="updateCampaignFromToggle"
        @set-loading="setLoading"
      />
    </div>

    <div class="form-block">
      <div class="flex flex-col fl-1">
        <label class="small-label">Название рекламной кампании</label>
        <SceletonInput :is-loading="isLoadingData">
          <IconField>
            <InputIcon
              class="pi"
              :class="
                isNameFilled
                  ? 'pi-check-circle violete'
                  : 'pi-exclamation-circle red'
              "
              v-tooltip="{
                value: getMessage(isNameFilled),
                class: 'white-tooltip',
              }"
            >
            </InputIcon>
            <InputText
              class="campaign-name"
              placeholder="Введите название"
              v-model="campaignName"
              :disabled="true"
            />
          </IconField>
        </SceletonInput>
      </div>
      <div
        class="info-block flex"
        v-if="customCatalogData.brand || customCatalogData.shop"
      >
        <span class="pi pi-info-circle info"></span>
        <div class="text">
          Если бренд или магазин указан вручную, Вы не сможете использовать
          данные кампаний для дашбордов или отчёта Sales Lift. Также нельзя
          отправить кампанию в те кабинеты, по которым идёт сбор статистики для
          дашбордов.
        </div>
      </div>
    </div>

    <div
      class="form-block"
      v-for="(segment, idx) in campaign.campaign_segments"
      :key="`segment-${idx}`"
      :class="[idx != campaign.campaign_segments.length - 1 ? 'hidden' : '']"
    >
      <div class="flex flex-end m-b-8">
        <div class="flex flex-col fl-1">
          <label class="small-label">Сегмент*</label>
          <SceletonInput :is-loading="isLoadingData">
            <CatalogDataSingleInput
              :is-invalid="isInvalidForm && segment.segment_id == null"
              selectType="segment"
              :isSegmentSetted="false"
              :modelValue="segment.segment"
              @update:modelValue="($event) => chooseSegment(segment, $event)"
            ></CatalogDataSingleInput>
          </SceletonInput>
        </div>
        <div class="flex fl-jc-sb f-s-0 m-l-20 m-b-7 m-l-20">
          <label
            class="p-r-20 pointer"
            for="updated"
            :class="[segment.updatable_locked ? 'locked' : '']"
            >Обновлять сегмент</label
          >
          <InputSwitch
            v-model="segment.is_segment_updatable"
            :disabled="segment.updatable_locked"
            inputId="updated"
          />
        </div>
      </div>

      <div class="flex some-inputs">
        <div class="flex flex-col m-r-8 input-container">
          <label class="small-label">Рекламная площадка*</label>
          <SceletonInput :is-loading="isLoadingData">
            <CatalogDataSingleInput
              :not-search="true"
              :use-id-only="true"
              selectType="platform"
              :is-invalid="isInvalidForm && segment.platform_slug == null"
              :isSegmentSetted="false"
              :modelValue="segment.platform_slug"
              @update:modelValue="($event) => (segment.platform_slug = $event)"
            ></CatalogDataSingleInput>
          </SceletonInput>
        </div>
        <div class="flex flex-col input-container">
          <label class="small-label">Кабинет*</label>
          <SceletonInput :is-loading="isLoadingData">
            <CatalogDataSingleInput
              :use-id-only="true"
              :filter-fields="adsCabinetFilterFields"
              :filter-values="[
                segment.platform_slug,
                ...adsCabinetFilterValues,
              ]"
              selectType="ads_cabinet"
              :is-disabled="segment.platform_slug == null"
              :is-invalid="isInvalidForm && segment.ads_cabinet_id == null"
              :isSegmentSetted="false"
              :modelValue="segment.ads_cabinet_id"
              @update:modelValue="($event) => (segment.ads_cabinet_id = $event)"
            ></CatalogDataSingleInput>
          </SceletonInput>
        </div>
      </div>

      <div
        class="flex f-s-0 m-t-12"
        v-if="authStore.getPayloadTenant() != rootGetters.inhouse_tenant"
      >
        <div class="p-r-20">
          <label
            class="pointer"
            for="renewal"
            :class="[segment.updatable_locked ? 'locked' : '']"
            >Включить автопродление сегмента</label
          >
          <span
            class="pi pi-info-circle icon-right"
            v-tooltip="{
              value:
                'Если автопродление не выбрано, то через месяц обновление и использование сегмента в кабинете будет остановлено.',
              class: 'white-tooltip',
            }"
          ></span>
        </div>
        <InputSwitch
          v-model="segment.is_segment_auto_renewable"
          :disabled="segment.updatable_locked"
          inputId="renewal"
        />
      </div>

      <div class="group-button-container flex">
        <div
          v-if="campaign.campaign_segments.length > 1"
          class="delete-button flex flex-center"
          @click="deleteSegment(idx)"
        >
          <span class="pi pi-trash"></span>
        </div>
        <div class="group-button flex flex-center" @click="addSegment(idx)">
          <span class="pi pi-plus"></span>
          <div class="p-l-10">Сегмент</div>
        </div>
      </div>
    </div>
    <DuplicatedCampaignDialog
      :id="duplicatedId"
      :visible="confirmVisible.duplicate"
      @close="confirmVisible.duplicate = false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";
import CalendarBaseInput from "@/shared/forms/CalendarBaseInput.vue";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import DuplicatedCampaignDialog from "@/shared/dialogs/DuplicatedCampaignDialog.vue";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import TechCampaignToggle from "./TechCampaignToggle.vue";

import { Brand } from "@/store/catalog_data/brands";
import { Shop } from "@/store/catalog_data/shops";
import { useCampaignStore, type Campaign } from "@/store/campaigns/campaigns";
import {
  getCampaignName,
  isCampaignNameValidated,
  isSegmentsFilled,
  isNotValidPeriod,
  prepareModelToServer,
  convertServerToModel,
} from "@/services/campaigns/utils";
import { rootGetters } from "@/main";
import { useAuthStore } from "@/store/auth/login";

const emit = defineEmits(["setCreateButton", "setLoading"]);
defineProps<{
  isLoading: boolean;
}>();

const route = useRoute();
const router = useRouter();
const store = useCampaignStore();
const authStore = useAuthStore();
const isNameFilled = ref(false);
const isInvalidForm = ref(false);
const confirmVisible = ref({
  duplicate: false,
});

const customCatalogData = ref({
  brand: false,
  shop: false,
});

const duplicatedId = ref(0);
const useNameDefault = ref(false);
const nameDefault = ref<typeof campaign.value | null>(null);
const isLoadingData = ref(false);

const campaign = ref({
  brand: null as Brand | null,
  shop: null as Shop | null,
  brand_name: "",
  shop_name: "",
  name: "",
  strategy: "",
  extra_info: "",
  date_from: null as Date | null,
  date_to: null as Date | null,
  campaign_segments: [
    {
      segment_id: null as number | null,
      segment: null as object | null,
      ads_cabinet_id: null as number | null,
      platform_slug: null as string | null,
      is_segment_updatable: false,
      updatable_locked: false,
      is_segment_auto_renewable: false,
    },
  ],
});

const campaignData = computed(() => campaign.value);

const campaignWatchFields = computed(() => ({
  brand: campaign.value.brand,
  shop: campaign.value.shop,
  name: campaign.value.name,
  strategy: campaign.value.strategy,
  extra_info: campaign.value.extra_info,
  date_from: campaign.value.date_from,
  date_to: campaign.value.date_to,
  brand_name: campaign.value.brand_name,
  shop_name: campaign.value.shop_name,
}));

const adsCabinetFilterFields = computed(() => {
  if (customCatalogData.value.brand || customCatalogData.value.shop)
    return ["source_slug", "is_statistics_required"];
  return ["source_slug"];
});

const adsCabinetFilterValues = computed(() => {
  if (customCatalogData.value.brand || customCatalogData.value.shop)
    return [false];
  return [];
});

const isCampaignSetted = computed(() => {
  return Boolean(route.params.id);
});

const campaignName = computed(() => {
  return getCampaignName(campaign.value, useNameDefault.value);
});

const chooseSegment = (segment: any, event: any) => {
  if (event) {
    segment.segment_id = event.id;
    if (event.is_fixed_end_date) segment.updatable_locked = true;
  } else {
    segment.segment_id = null;
  }

  segment.segment = event;
};

const reload = () => {
  if (isCampaignSetted.value || store.duplicateCampaignId) {
    const campaignIdParam = Array.isArray(route.params.id)
      ? route.params.id[0]
      : route.params.id;
    const campaignId =
      parseInt(campaignIdParam as string) || store.duplicateCampaignId;
    isLoadingData.value = true;
    store.getCampaign(campaignId).then((campaignClone) => {
      if (campaignClone) {
        campaign.value = convertServerToModel(campaignClone);
        useNameDefault.value = true;
        isLoadedFirst.value = true;
        nameDefault.value = JSON.parse(JSON.stringify(campaign.value));
        customCatalogData.value.brand = !!campaign.value.brand_name;
        customCatalogData.value.shop = !!campaign.value.shop_name;
      }
      if (store.duplicateCampaignId) {
        const extraValue = campaign.value.extra_info
          ? campaign.value.extra_info
          : "";
        campaign.value.extra_info = extraValue + "копия";
      }
      isLoadingData.value = false;
    });
  }
};

onMounted(() => {
  reload();
});

watch(
  () => campaignName.value,
  () => {
    isNameFilled.value = isCampaignNameValidated(campaign.value);
  }
);

watch(
  () => route.params.id,
  () => {
    reload();
  }
);

const isLoadedFirst = ref(true);

watch(campaignWatchFields, (newValue) => {
  if (nameDefault.value) {
    const defaultVal = nameDefault.value;
    if (
      (!isLoadedFirst.value || store.duplicateCampaignId) &&
      useNameDefault.value &&
      (newValue.extra_info !== defaultVal.extra_info ||
        newValue.brand !== defaultVal.brand ||
        newValue.shop !== defaultVal.shop ||
        newValue.strategy !== defaultVal.strategy ||
        newValue.date_from !== defaultVal.date_from ||
        newValue.date_to !== defaultVal.date_to ||
        newValue.brand_name !== defaultVal.brand_name ||
        newValue.shop_name !== defaultVal.shop_name)
    ) {
      useNameDefault.value = false;
    }
  }
  if (useNameDefault.value != undefined) isLoadedFirst.value = false;
});

const addSegment = (idx: number) => {
  campaign.value.campaign_segments.splice(idx + 1, 0, {
    segment_id: null,
    ads_cabinet_id: null,
    segment: null,
    platform_slug: null,
    is_segment_updatable: false,
    updatable_locked: false,
    is_segment_auto_renewable: false,
  });
};

const deleteSegment = (idx: number) => {
  campaign.value.campaign_segments.splice(idx, 1);
};

const createCampaign = () => {
  if (!isNameFilled.value || !isSegmentsFilled(campaign.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены и наименования бренда и магазина не содержат нижнее подчеркивание.`
    );
    return;
  } else if (isNotValidPeriod(campaign.value)) {
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Дата начала периода не может быть больше даты окончания.`
    );
    return;
  }
  campaign.value.name = campaignName.value;
  const campaignForCreation = prepareModelToServer(campaign.value);
  if (campaignForCreation) {
    emit("setLoading", true);
    if (isCampaignSetted.value) {
      const campaignIdParam = Array.isArray(route.params.id)
        ? route.params.id[0]
        : route.params.id;
      const campaignId = parseInt(campaignIdParam as string);
      performCampaignAction(() =>
        store.updateCampaign(campaignForCreation, campaignId)
      );
    } else {
      performCampaignAction(() => store.createCampaign(campaignForCreation));
    }
  }
};

const performCampaignAction = (action: any) => {
  const handleCampaignSuccess = () => {
    router.push({ name: "listCampaigns" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  const handleCampaignError = (err: any) => {
    if (err.response && err.response.status == 409)
      store.getCampaignByName(campaign.value.name).then((id) => {
        if (id) {
          duplicatedId.value = id;
          confirmVisible.value.duplicate = true;
        }
      });

    if (err.response && err.response.status == 403)
      rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
  };

  action()
    .then(handleCampaignSuccess)
    .catch(handleCampaignError)
    .finally(() => {
      emit("setLoading", false);
    });
};

const getMessage = (isNameFilled: boolean) => {
  if (isNameFilled) return "Наименование рекламной кампании корректно";
  return "Наименование рекламной кампании некорректно";
};

const hasBrandSelected = () => {
  return campaign.value.brand != null;
};

const setLoading = (value: boolean) => {
  emit("setLoading", value);
};

const updateCampaignFromToggle = (value: Campaign) => {
  Object.assign(campaign.value, value);
};

defineExpose({
  createCampaign,
  hasBrandSelected,
});
</script>

<style lang="scss" scoped>
.form-filter {
  max-width: 100%;
  width: 100%;
  padding-bottom: 40px;
  min-width: 780px;
}

.form-block {
  transition: all 3s ease-in;
}

.form-block.hidden .group-button-container {
  visibility: hidden;
}

.form-block.hidden:hover .group-button-container {
  visibility: visible;
}

.form-block-title {
  margin-bottom: 12px;
  color: $main-font-color;
}

.some-inputs {
  max-width: 100%;
}

.input-container {
  max-width: calc(50% - 4px);
  width: calc(50% - 4px);
}

.small-label {
  color: #a19cab;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.43rem;
  padding-bottom: 4px;
  padding-left: 4px;
}

label.locked {
  color: #a19cab;
  cursor: default;
}

:deep(.p-inputtext.p-component) {
  width: 100%;
}

:deep(.p-inputtext:disabled),
:deep(.p-dropdown.p-disabled),
:deep(.p-multiselect.p-disabled) {
  background-color: $page-background-color;
}

.p-inputtext.campaign-name:disabled {
  background-color: white;
  color: $main-font-color;
}

.group-button-container {
  justify-content: flex-end;
  margin-top: 12px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s, outline-color 0.2s;

  .delete-button {
    background-color: #fff;
    padding: 8px 8px;
    border-radius: 6px;
    margin-right: 12px;
    cursor: pointer;

    &:hover {
      background-color: #fafaff;
    }
  }

  .group-button {
    background-color: #dbdaf9;
    border-radius: 5px;
    padding: 7px 14px;
    cursor: pointer;

    &:hover {
      background-color: #d4d3f8;

      outline-color: transparent;
    }
  }
}

.p-icon-field-right > .p-input-icon:last-of-type.violete {
  color: #6b69e8;
}

.p-icon-field-right > .p-input-icon:last-of-type.red {
  color: #cd4364;
}

.icon-right {
  position: relative;
  cursor: pointer;
  top: 2px;
  left: 5px;
}

.hand {
  margin-left: 2px;
  margin-top: 2px;
  font-size: 0.9rem;
  color: #a19cab;

  div span {
    cursor: pointer;
    padding-bottom: 0.5px;
    width: fit-content;
    border-bottom: 1px dotted #a19cab;
  }
}

.info-block {
  margin-top: 10px;
  margin-bottom: 7px;

  .info {
    font-size: 0.85rem;
    padding-top: 1px;
  }

  .text {
    font-size: 0.85rem;
    line-height: 1rem;
    padding-left: 8px;
  }
}
</style>
